import React, { Fragment, memo } from "react";

import { Mobile, NotMobile } from "../../../../../common/Responsive";
import { DeviceActionsToggle, DeviceMenu } from "../tableComponents";
import { ProfileDeviceMenuProps } from "./ProfileDeviceMenu";
import {
  RenameDeviceDropdownItem,
  RenameDeviceModalItem,
  MoveDeviceDropdownItem,
  MoveDeviceModalItem,
  MergeAssignedDeviceDropdownItem,
  MergeAssignedDeviceModalItem,
  RemoveDeviceDropdownItem,
  RemoveDeviceModalItem,
  UnmergeDeviceDropdownItem,
  UnmergeDeviceModalItem,
} from "../deviceActionItems";
import { isAssignedDeviceMerged } from "../../../../../store/devices";

export const ProfileNonRoamingDeviceMenu = memo(
  function ProfileNonRoamingDeviceMenu({ device }: ProfileDeviceMenuProps) {
    const isUnmergeAvailable = isAssignedDeviceMerged(device);
    const isMergeAvailable = !isUnmergeAvailable;

    const dropdownItems = [
      <RenameDeviceDropdownItem device={device} />,
      <MoveDeviceDropdownItem device={device} />,
      isMergeAvailable && <MergeAssignedDeviceDropdownItem device={device} />,
      isUnmergeAvailable && <UnmergeDeviceDropdownItem device={device} />,
      <RemoveDeviceDropdownItem device={device} />,
    ].filter(Boolean);

    const modalItems = [
      <RenameDeviceModalItem device={device} />,
      <MoveDeviceModalItem device={device} />,
      isMergeAvailable && <MergeAssignedDeviceModalItem device={device} />,
      isUnmergeAvailable && <UnmergeDeviceModalItem device={device} />,
      <RemoveDeviceModalItem device={device} />,
    ].filter(Boolean);

    return (
      <Fragment>
        <Mobile>
          <DeviceActionsToggle
            deviceName={device.name || device.networkId}
            menuItems={modalItems}
          />
        </Mobile>

        <NotMobile>
          <DeviceMenu className="profile-device-menu" items={dropdownItems} />
        </NotMobile>
      </Fragment>
    );
  }
);
